<!-- 学习班 添加 -->
<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>
    <el-card class="box-card">
      <div class="form_box__item">
        <div class="form_box__item__input">
          <span>用 户 名 :</span>
          <el-input v-model="username" placeholder="请输入用户名"></el-input>
        </div>
      </div>

      <div class="form_box__item">
        <div class="form_box__item__input">
          <span>密码类型:</span>
          <muserPtypeSelect @setPtype="getPtype"></muserPtypeSelect>
        </div>
      </div>
      <div class="form_box__item">
        <div class="form_box__item__input">
          <span>绑定手机:</span>
          <el-input v-model="phone" placeholder="请输入手机号(选填)"></el-input>
        </div>
      </div>
      <div class="form_box__item">
        <div class="form_box__item__input">
          <MuserRoleConfigBox ref="MuserRoleConfigBox" @powerChange="getPowerInfo" @onChangedIsAdmin="onChangedIsAdmin"></MuserRoleConfigBox>
        </div>
      </div>
    </el-card>

    <el-card class="form_box__main_box__input_group mt-2">
      <el-button style="margin-top: 12px;" type="primary" @click="save">完成</el-button>
    </el-card>
  </div>
</template>
<script>
import { BaseVue } from "@/mixin/index";
import { muserAddApi } from "@/api/module/muser/muser";
import Base64 from "js-base64";
import {
  // muserTypeSelect,
  muserPtypeSelect,
  MuserRoleConfigBox,
} from "@/views/module/muser/component/index";

export default {
  name: "MuserAdd",
  
  mixins: [BaseVue],
  
  components: {
    // muserTypeSelect,
    muserPtypeSelect,
    // studyclassUnitidSelect,
    MuserRoleConfigBox,
  },
  
  data() {
    return {
      loading: false,
      username: "",
      ptype: "0", // 密码类型
      password: "",
      phone: "",
      rpassword: "", // 校验密码
      adminType: 0, // 是不是系统管理员
      rid: "", // 权限类型
      partyid: [], // 绑定的组织管理员
      unitid: [], // 绑定的单位管理员
      isadminVal: 1
    };
  },
  
  methods: {
    // 获取权限信息
    getPowerInfo(e) {
      this.rid = e.role;
      if (e.role == '00002') {
        this.partyid = e.rid[e.rid.length - 1];
      }
      if (e.role == '00003') {
        this.unitid = e.rid[e.rid.length - 1];
      }
    },
    
    // 获取密码相关信息
    getPtype(e) {
      this.password = e.password;
      this.rpassword = e.rpassword;
      this.ptype = e.ptype;
    },
    
    save() {
      this.loading = true;
      if (this.username.length <= 0) {
        this.$message.error("请输入用户名！");
        this.loading = false;
        return false;
      }
      if (this.ptype == 1) {
        if (this.password.length <= 0) {
          this.$message.error("请填写密码！");
          this.loading = false;
          return false;
        }
        if (this.password != this.rpassword) {
          this.$message.error("两次密码不一致！");
          this.loading = false;
          return false;
        }
      }
      
      let phone = this.phone;
      let username = this.username;
      let ptype = this.ptype;
      let p = Base64.Base64.encode(this.password); // 加密后的密码
      let isadmin = this.isadminVal;
      let rid = this.rid;
      let unitid = this.unitid;
      let partyid = this.partyid;
      let data = {
        username,
        ptype,
        p,
        phone,
        isadmin,
        rid,
        unitid,
        partyid
      };
      
      muserAddApi(data)
        .then((response) => {
          this.$message({
            message: "操作成功！",
            type: "success",
          });
          setTimeout(() => {
            this.$router.replace({
              path: "/standard/muser/muserList",
            });
          }, 1500);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    onChangedIsAdmin(val) {
      this.isadminVal = val;
    }
  },
  
  mounted() {
    this.$refs.MuserRoleConfigBox.initData(false);
  }
};
</script>

<style scoped lang="scss">
.form_box {
  .form_box__item {
    margin-bottom: 15px;
    font-size: 14px;
    color: #303133;
    span {
      margin-right: 50px;
      white-space: nowrap;
    }
    .form_box__item__input {
      margin-left: 0;
    }
  }
}
</style>

